import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { STATUS } from "../../constant"
import centralApi from "../../../services/centralApi"
import { CampaignChannelTypeEnum } from "utils/enums"
interface paramType {
  api_key: string
  app_id: string
  template_type:CampaignChannelTypeEnum
 
}
export const fetchTemplatesList = createAsyncThunk(
  "templates/fetchTemplatesList",
  async (params: paramType) => {
    return centralApi(
      "GET",
      "o/templates/getTemplatesByType",
      null,
      params
    ).then(({ result,total_count }) => {
      result.total_count = total_count;
      return result
    })
  }
)
const initialState: any = {
  data: [],
  status: STATUS.IDLE,
}
const templatesListSlice = createSlice({
  name: "templatesList",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchTemplatesList.pending, (state) => {
      state.status = STATUS.LOADING
    })
    builder.addCase(fetchTemplatesList.fulfilled, (state, action) => {
      state.status = STATUS.IDLE
      state.data = action.payload
    })
    builder.addCase(fetchTemplatesList.rejected, (state) => {
      state.status = STATUS.ERROR
    })
  },
  reducers: {},
})
export default templatesListSlice.reducer
